import CustomersEntityFilters from './CustomersEntityFilters';

export default CustomersEntityFilters;
